import styled from "styled-components";
import { popUpIndex } from "../../config/zIndex";

export const PopUpBackground = styled.div`
  width: 100%;
  height: 100vh;
  display: ${({ isShowed }) => (isShowed ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${popUpIndex};
`;
